"use client";

import { useEffect } from "react";
import { Grid } from "@mui/material";
import CategoryCard from "@/components/CategoryCard";
import { Category } from "@/types";
import { useToastMessageHandler } from "../ToastMessage";

interface CategoryGridProps {
  categories: Category[];
}

const CategoryGrid = ({ categories }: CategoryGridProps) => {
  const { ToastMessage, showToast } = useToastMessageHandler();

  useEffect(() => {
    if (categories.length === 0) {
      showToast({
        type: "warning",
        title: "Kategori bulunamadı",
        message: "Görüntülenecek ürün bulunamadı.",
        displayTime: 4000,
      });
    }
  }, [categories.length, showToast]);

  return (
    <>
      <ToastMessage />
      <Grid container spacing={4} width="100%" my={4}>
        {categories?.map((category) => (
          <Grid key={category.slug} size={{ xs: 12, sm: 6, md: 4 }}>
            <CategoryCard
              title={category.title}
              image={category.image}
              slug={category.slug}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default CategoryGrid;
